// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
* {
  font-family: "Montserrat", sans-serif;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  min-height: calc(100vh - 126.5px);
}
@media screen and (min-width: 768px) {
  .container {
    min-height: calc(100vh - 126.5px - 32px);
  }
}

.swal-custom.swal-custom--danger {
  background-color: #6ba7a8;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAEA;;EAEE,qCAAA;AAAF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AACF;AACE;EANF;IAOI,wCAAA;EAEF;AACF;;AAEE;EACE,yBAAA;AACJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap\");\n\nhtml,\n* {\n  font-family: \"Montserrat\", sans-serif;\n}\n.container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 0 24px;\n  min-height: calc(100vh - 126.5px);\n\n  @media screen and (min-width: 768px) {\n    min-height: calc(100vh - 126.5px - 32px);\n  }\n}\n\n.swal-custom {\n  &.swal-custom--danger {\n    background-color: #6ba7a8;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
